import {mapState} from "vuex";
export default {
    methods: {
        focusTrue() {
            if(!this.$isMobile) {
                this.focusParam = true;
            }
        },
        focusFalse() {
            if(!this.$isMobile) {
                this.focusParam = false;
            }
        },
        getUrl(picture) {
            return require(`@/assets/${ picture }`)
        },
        getUrlIcons(picture) {
            return require(`@/assets/icons/${ picture }.svg`)
        },
        getUrlLogo(picture) {
            return require(`@/assets/logo/${ picture }.svg`)
        },


        formatFullDateRu(date)  {
            return new Date(date).toLocaleDateString("ru-RU", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
        },
        isVisible(index) {
            return index <= this.visibleIndexItem
        },

        uploadFile(fileUrl, title) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', title);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },


        showAnimation() {
            this.visibleIndexItem = 0;
            this.showNextItem();
        },
        showNextItem() {
            if (this.visibleIndexItem < this.lengthAnimation) {
                setTimeout(() => {
                    this.visibleIndexItem += 1;
                    this.showNextItem();
                }, 200)
            }
        }

    },
    computed: {
        ...mapState(['$isMobile']),
    },
}